import { toast } from 'sonner'
import DetectRTC from 'detectrtc'

let isAudioAccessibleCache = null
let audioAccessibleErrorMsg = ''

export const hasAudioPermission = async () => {
  try {
    await navigator.mediaDevices.getUserMedia({ audio: true })
    return true
  } catch (error) {
    console.error(error)
    return false
  }
}

export const checkIsAudioAccessible = async (
  options = {
    showError: true,
    errorMessage:
      'Bạn cần cấp quyền truy cập Microphone để sử dụng chức năng thoại!',
  },
) => {
  if (isAudioAccessibleCache) return true

  if (isAudioAccessibleCache !== null) {
    options?.showError && toast.error(options?.errorMessage)
    return false
  }

  if (!DetectRTC.isWebRTCSupported) {
    audioAccessibleErrorMsg =
      'Trình duyệt của bạn không hỗ trợ phương thức nghe gọi!'
    options?.showError && toast.error(audioAccessibleErrorMsg)
    isAudioAccessibleCache = false
    return
  }

  isAudioAccessibleCache = await hasAudioPermission()
  if (!isAudioAccessibleCache) {
    options?.showError && toast.error(options?.errorMessage)
    return
  }

  isAudioAccessibleCache = true
  return true
}

export const getHref = () => {
  const { origin, href } = window.location
  return href.replace(origin, '')
}
